import { Injectable } from "@angular/core";
import { Restangular, RestangularModule } from "ngx-restangular";

@Injectable()
export class ConfigurationService {
  constructor(private restangular: Restangular) {}

  public getFormData() {
    return this.restangular.one("getAllEmployeesFormData");
  }

  public getAllDepartments() {
    return this.restangular.all("getAllDepartments");
  }

  public departmentsCRUD() {
    return this.restangular.all("departmentsCRUD");
  }

  public departmentsUD(id) {
    return this.restangular.one("departmentsCRUD/" + id);
  }

  public getAllProjects() {
    return this.restangular.all("getAllProjects");
  }
  public getProjects() {
    return this.restangular.all("getProjects");
  }

  public projectsCRUD() {
    return this.restangular.all("projectsCRUD");
  }

  public projectUD(id) {
    return this.restangular.one("projectsCRUD/" + id);
  }

  public getAllRigs() {
    return this.restangular.all("getAllRigs");
  }

  public rigsCRUD() {
    return this.restangular.all("rigsCRUD");
  }

  public rigUpdate(id) {
    return this.restangular.one("rigsCRUD/" + id);
  }

  public getAllCustomers() {
    return this.restangular.all("getAllCustomers");
  }

  public customersCRUD() {
    return this.restangular.all("customersCRUD");
  }

  public customersUD(id) {
    return this.restangular.one("customersCRUD/" + id);
  }

  public getAllSafetyObservationTypes() {
    return this.restangular.all("getAllSafetyObservationTypes");
  }

  public getAllSafetyObservationFormData() {
    return this.restangular.one("getAllSafetyObservationFormData");
  }

  public SafetyObservationTypesCRUD() {
    return this.restangular.all("SafetyObservationTypesCRUD");
  }

  public SafetyObservationTypeUD(id) {
    return this.restangular.one("SafetyObservationTypesCRUD/" + id);
  }

  public incidentCrossTable() {
    return this.restangular.all("incidentCrossTable");
  }

  public incidentCrossStore() {
    return this.restangular.all("incident_crosses");
  }

  public getIncidentCross() {
    return this.restangular.all("getIncidentCross");
  }

  public incidentCrossDelete(id) {
    return this.restangular.all("incident_crosses/" + id);
  }

  public getIncidentCategoriesFormData() {
    return this.restangular.one("getIncidentCategoriesFormData");
  }

  public getAllEmergencyContactTable() {
    return this.restangular.all("getAllEmergencyContactTable");
  }

  public getEmergencyContactFormData() {
    return this.restangular.one("getEmergencyContactFormData");
  }

  public removeEmergencyContact(id) {
    return this.restangular.one("emergency_contacts/" + id);
  }

  public getTypeheadEmployees() {
    return this.restangular.one("getTypeheadEmployees");
  }

  public getTypeheadEmployeesMulti() {
    return this.restangular.one("getTypeheadEmployeesMulti");
  }

  public addEmergency() {
    return this.restangular.all("emergency_contacts");
  }

  public getAllWorkPlaces() {
    return this.restangular.all("getAllWorkPlaces");
  }

  public workPlacesCRUD() {
    return this.restangular.all("workPlacesCRUD");
  }

  public workPlacesUD(id) {
    return this.restangular.one("workPlacesCRUD/" + id);
  }

  public getAllEmailNotifications() {
    return this.restangular.all("getAllEmailNotifications");
  }

  public emailNotificationsCRUD() {
    return this.restangular.all("email_notifications");
  }

  public emailNotificationUD(id) {
    return this.restangular.one("email_notifications/" + id);
  }

  public getChecklistFormData() {
    return this.restangular.one("getChecklistFormData");
  }

  public getDocumentIncidentTypes() {
    return this.restangular.one("getDocumentIncidentTypes");
  }

  public getAllChecklistMaster() {
    return this.restangular.all("getAllChecklistMaster");
  }

  checklistTemplateCategoriesCRUD() {
    return this.restangular.all("checklistTemplateCategories");
  }

  checklistTemplateCategoriesUD(id) {
    return this.restangular.all("checklistTemplateCategories/" + id);
  }

  checklistTemplateCriteriaUD(id) {
    return this.restangular.one("checklistTemplateCriterias/" + id);
  }

  public getAllIncidentCausationMaster() {
    return this.restangular.all("getAllIncidentCausationMaster");
  }

  public getIncidentCausationDetails() {
    return this.restangular.one("getIncidentCausationDetails");
  }

  public incidentCausationCRUD() {
    return this.restangular.all("incident_causations");
  }

  public incidentCausationRemove(id) {
    return this.restangular.all("incident_causations/" + id);
  }

  public incidentCausationMasterCRUD() {
    return this.restangular.all("incident_causation_masters");
  }

  public incidentCausationMasterRemove(id) {
    return this.restangular.all("incident_causation_masters/" + id);
  }

  public getCustomerLastSortID() {
    return this.restangular.one("getCustomerLastSortID");
  }

  checklistSummarizeUD(id) {
    return this.restangular.one("checklist_summarize_calculations/" + id);
  }

  public checklistLastScoringRange() {
    return this.restangular.one("checklistLastScoringRange");
  }

  checklistTemplateGuidlinesCRUD() {
    return this.restangular.all("checklist_guidelines");
  }

  public getAllVehicleList() {
    return this.restangular.all("getAllVehicleList");
  }

  public vehicleMasterCRUD() {
    return this.restangular.all("vehicle_masters");
  }

  public getAllTicketStatusList() {
    return this.restangular.all("getAllTicketStatusList");
  }

  public getSystemPurposeStatuses() {
    return this.restangular.one("purpose_of_statuses");
  }

  public ticketStatusMasterCRUD() {
    return this.restangular.all("ticket_statuses");
  }

  public getAllYears() {
    return this.restangular.all("getAllYears");
  }

  public addYear() {
    return this.restangular.all("storeYears");
  }

  public removeYear() {
    return this.restangular.all("removeYear");
  }

  public getAllDocumentsForDropdown() {
    return this.restangular.all("getAllDocumentsForDropdown");
  }

  public geDocumentMasterData() {
    return this.restangular.one("getAllDocumentDataFromDocId");
  }

  updateCurrentDocumentSettings() {
    return this.restangular.all("updateCurrentDocumentSettings");
  }

  public getAllChecklists() {
    return this.restangular.one("getAllChecklists");
  }

  public projectsAddAllEmployees() {
    return this.restangular.all("projectsAddAllEmployees");
  }

  public pendingProjectsEmployeesAll() {
    return this.restangular.all("pendingProjectsEmployeesAll");
  }


  // public addedProjectsEmployees() {
  //   return this.restangular.one("addedProjectsEmployees");
  // }

  public addedProjectsEmployees() {
    return this.restangular.all("addedProjectsEmployees");
  }


  
  public pendingProjectsEmployees() {
    return this.restangular.one("pendingProjectsEmployees");
  }
  
  public addNewEmployeeToProject() {
    return this.restangular.all("addNewEmployeeToProject");
  }

  public removeOneEmployeeInProject() {
    return this.restangular.all("removeOneEmployeeInProject");
  }




 // ---------- OBJECTIVE MASTERS ----------- //
  public getAllObjectiveRatings() {
    return this.restangular.all("getAllObjectiveRatings");
  }


  public removeObjectiveRatings(id) {
    return this.restangular.one('removeObjectiveRatings/' + id);
  }


  public addNewObjectiveRatings() {
    return this.restangular.all("addNewObjectiveRatings");
  }

  
  public editRatingMaster() {
    return this.restangular.all("editRatingMaster");
  }








  public getAllObjectiveElements() {
    return this.restangular.all("getAllObjectiveElements");
  }


  public getProofPointsMaster(id) {
    return this.restangular.one("getProofPointsMaster/" + id);
  }

  public getAllObjectiveProficiencyAll() {
    return this.restangular.all("getAllObjectiveProficiencyAll");
  }

  public removeDependancyProofPoint(id) {
    return this.restangular.one("removeDependancyProofPoint/" + id);
  }



  public addProofPoints() {
    return this.restangular.all("addProofPoints");
  }

  public editProofPoints() {
    return this.restangular.all("editProofPoints");
  }

  
  public addNewRowToDetailTemplate() {
    return this.restangular.all("addNewRowToDetailTemplate");
  }







  // public getAllObjectiveProficiency() {
  //   return this.restangular.all("getAllObjectiveProficiency");
  // }

  public getAllObjectiveProficiency(id) {
    return this.restangular.one("getAllObjectiveProficiency/" + id);
  }




  public removeObjectiveElement(id) {
    return this.restangular.one('removeObjectiveElement/' + id);
  }


  public addNewObjectiveElement() {
    return this.restangular.all("addNewObjectiveElement");
  }


  public editObjectiveElement() {
    return this.restangular.all("editObjectiveElement");
  }





  
  // public getAllObjectiveProficiency(id) {
  //   return this.restangular.one("getAllObjectiveProficiency/" + id);
  // }


  public removeObjectiveProficiency(id) {
    return this.restangular.one('removeObjectiveProficiency/' + id);
  }


  public addNewObjectiveProficiency() {
    return this.restangular.all("addNewObjectiveProficiency");
  }

  public editProficiencyMaster() {
    return this.restangular.all("editProficiencyMaster");
  }


  public getDependancyProficiency(id) {
    return this.restangular.one("getDependancyProficiency/" + id);
  }

  public updateNewDependancyProficiency() {
    return this.restangular.one("updateNewDependancyProficiency");
  }

  public removeDependancyProficiency(id) {
    return this.restangular.one("removeDependancyProficiency/" + id);
  }


  
  public editDependancyProficiency() {
    return this.restangular.all("editDependancyProficiency");
  }


  public updateRatingRecordMaster(id) {
    return this.restangular.one("updateRatingRecordMaster/" + id);
  }



}



// WEBPACK FOOTER //
// /app/src/app/services/configuration.service.ts